// Helpers de avatar (iniciais + cor determinística por usuário).
// Extraídos de UserAvatar.tsx para um arquivo não-componente
// (regra react-refresh/only-export-components exige que arquivos de
// componente só exportem componentes).

const avatarColors = [
  'bg-info/10 text-info',
  'bg-error/10 text-error',
  'bg-log-fatal/10 text-log-fatal',
  'bg-offline/10 text-offline',
  'bg-success/10 text-success',
  'bg-primary/10 text-primary',
];

export function getUserInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return parts.length >= 2
    ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
    : name.slice(0, 2).toUpperCase();
}

export function getAvatarColor(userId: string): string {
  const hash = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return avatarColors[hash % avatarColors.length];
}
